import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  useToast
} from "@chakra-ui/react";

import { useEffect, useState } from "react";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  initialData?: any;
}

function formatCPF(value: string) {
  const cleaned = (value || "").replace(/\D/g, "").slice(0, 11);

  if (cleaned.length <= 3) return cleaned;
  if (cleaned.length <= 6) return `${cleaned.slice(0, 3)}.${cleaned.slice(3)}`;
  if (cleaned.length <= 9) return `${cleaned.slice(0, 3)}.${cleaned.slice(3, 6)}.${cleaned.slice(6)}`;

  return `${cleaned.slice(0, 3)}.${cleaned.slice(3, 6)}.${cleaned.slice(6, 9)}-${cleaned.slice(9, 11)}`;
}

export default function FormModal({
  isOpen,
  onClose,
  onSave,
  initialData
}: Props) {

  const toast = useToast();

  const [form, setForm] = useState({
    nome: "",
    cpf: "",
    profissao: ""
  });

  useEffect(() => {
    if (initialData) {
      setForm({
        nome: initialData.nome ?? "",
        cpf: formatCPF(initialData.cpf ?? ""),
        profissao: initialData.profissao ?? ""
      });
      return;
    }

    setForm({
      nome: "",
      cpf: "",
      profissao: ""
    });
  }, [initialData, isOpen]);

  function handleSave() {
    if (!form.nome.trim()) {
      toast({ title: "Informe o nome", status: "error" });
      return;
    }

    if (!form.profissao.trim()) {
      toast({ title: "Informe a profissão", status: "error" });
      return;
    }

    const cpf = form.cpf.replace(/\D/g, "");
    if (cpf && cpf.length !== 11) {
      toast({ title: "CPF inválido", status: "error" });
      return;
    }

    onSave(form);
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />

      <ModalContent>
        <ModalHeader>
          {initialData ? "Editar Profissional" : "Novo Profissional"}
        </ModalHeader>

        <ModalBody>
          <VStack spacing={4}>
            <FormControl>
              <FormLabel>Nome</FormLabel>
              <Input
                value={form.nome}
                onChange={(e) => setForm({ ...form, nome: e.target.value })}
              />
            </FormControl>

            <FormControl>
              <FormLabel>CPF (opcional)</FormLabel>
              <Input
                value={form.cpf}
                placeholder="000.000.000-00"
                onChange={(e) => setForm({ ...form, cpf: formatCPF(e.target.value) })}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Profissão</FormLabel>
              <Input
                value={form.profissao}
                onChange={(e) => setForm({ ...form, profissao: e.target.value })}
              />
            </FormControl>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button mr={3} onClick={onClose}>
            Cancelar
          </Button>

          <Button colorScheme="blue" onClick={handleSave}>
            Salvar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
